import SearchIcon from "../../assets/images/search-lg-icon.svg";
import filterLines from "../../assets/images/filter-lines.svg";
import downloadIcon from "../../assets/images/download-icon.svg";
import trashIcon from "../../assets/images/trash-icon.svg";
import threeDots from "../../assets/images/dots-vertical.svg";
import mediator from "../../assets/images/mediator.svg";
import mediatorLetter from "../../assets/images/m-mediator.svg";
import shareicon from "../../assets/images/share.svg";
import influencer from "../../assets/images/influencer.svg";
import Pioneer from "../../assets/images/pioneer.svg";
import logicalthinker from "../../assets/images/logical-thinker.svg";
import teamplayer from "../../assets/images/team-player.svg";
import persuader from "../../assets/images/persuader.svg";
import achiever from "../../assets/images/achiever.svg";
import perfectionist from "../../assets/images/perfectionist.svg";
import collaborator from "../../assets/images/collaborator.svg";
import assessor from "../../assets/images/accessor.svg";
import implementor from "../../assets/images/implementor.svg";
import motivator from "../../assets/images/motivator.svg";
import leader from "../../assets/images/leader.svg";
import administrator from "../../assets/images/administrator.svg";
import versatile from "../../assets/images/versatile.svg";

import versatileletter from "../../assets/images/versatileletter.svg";
import influencerletter from "../../assets/images/i-influencer.svg";
import pioneerletter from "../../assets/images/p-pioneer.svg";
import logicalthinkerletter from "../../assets/images/l-logical.svg";
import teamplayerletter from "../../assets/images/t-teamplayer.svg";
import persuaderletter from "../../assets/images/p-persuader.svg";
import achieverletter from "../../assets/images/a-achiever.svg";
import perfectionistletter from "../../assets/images/p-perfectionist.svg";
import collaboratorletter from "../../assets/images/c-collaborator.svg";
import assessorletter from "../../assets/images/a-accessor.svg";
import implementorletter from "../../assets/images/i-implementor.svg";
import motivatorletter from "../../assets/images/m-motivator.svg";
import leaderletter from "../../assets/images/l-leader.svg";
import administratorletter from "../../assets/images/a-aadministrator.svg";
import mediatorletter from "../../assets/images/m-mediator.svg";
import downloadicon from "../../assets/images/download-icon.svg";
import one from "../../assets/images/one-circle.svg";
import two from "../../assets/images/two-circle.svg";
import check from "../../assets/images/check.svg";
import mail from "../../assets/images/mail.svg";
import crosscircle from "../../assets/images/cross.svg";
import whatsappss from "../../assets/images/whatsapp.png";
import downl from "../../assets/images/download.svg";





export const personalitiesList = [
  {
    id: 1,
    img_card: influencer,
    img_letter: influencerletter,
    personality: "Influencer",
    text: "Influencers are confident, outgoing and friendly individuals who love to be the center of attention. They seek out situations that involve meeting people and socializing. Their confidence combined with a genuine interest in ideas and people, allows them to interact easily, and positively in almost any situation. These strong communicators are assertive, intuitive, and adaptive. They thrive in meetings, committees, and conferences. They may need a constant dose of Approval. They also might sometimes lose focus on timelines and the tasks at hand.",
    strengths:
      "Fun, persuasive, ideas-oriented, creative, original, networkers, intuitive",
    uniqueness: "Openness, strong communication, social confidence",
    valtoorg:
      "Contributing original ideas, improve and extend coordination within team",
    challenges: "Needs constant approval, pressured conditions",
    motivations:
      "Being surrounded by people, supportive and collaborative environment",
  },
  {
    id: 2,
    img_card: Pioneer,
    img_letter: pioneerletter,
    personality: "Pioneer",
    text: "Pioneers are often ambitious, competitive, and strong-willed individuals. They have a very high need to achieve and continually seek new horizons. Their self-reliance and independent thinking drive them to escape convention and create innovative solutions. They are direct and assertive and apt at influencing people. They are dynamic, adaptable, and willing to do anything to overcome obstacles. Pioneers are persistent in their pursuit of desired results. Overcome by their desire to achieve their goals, they might fail to take other people’s feelings into consideration. Additionally, they have high expectations of others and can be critical if their standards are not met.",
    strengths:
      "Action-oriented, resourceful, self-reliant, decisive, proactive, strong-willed, direct",
    uniqueness:
      "Sound decision making, self-motivated, excels in emergencies",
    valtoorg: "Innovative solutions; taking responsibility",
    challenges: "Too independent, tends to be blunt, boredom",
    motivations:
      "New opportunities, strong need to achieve, power and structure.",
  },
  {
    id: 3,
    img_card: logicalthinker,
    img_letter: logicalthinkerletter,
    personality: "Logical Thinker",
    text: "Logical thinkers are hardworking, logical, and detail-oriented individuals with high critical thinking abilities. Their habit of meticulous preparation, accuracy, and correctness helps them to manage tasks effectively. Despite being shy and mild-mannered, logical thinkers have a strong need to control their environment. They exert rules, structure, and standards, to accomplish their goals, in conflicting situations. Their cautiousness makes them reluctant to reveal information about themselves or their thoughts unless necessary. Being natural risk avoiders, they only undertake tasks when they are completely certain about the outcome.",
    strengths:
      "Quality control, handling detail, analyzing data, logical, avoiding the risk, building structure, being deliberate and methodical",
    uniqueness: "Accuracy; ability to think logically; building structure",
    valtoorg:
      "Completes the undertaken task; great at quality control; organizing information",
    challenges:
      "Spotting deficiencies first; controlling; lacks assertiveness",
    motivations:
      "Certainty of situation and consequences; getting things right",
  },
  {
    id: 4,
    img_card: teamplayer,
    img_letter: teamplayerletter,
    personality: "Team Player",
    text: "Team players are friendly, calm, and thoughtful individuals that like doing practical jobs. Amidst their calm nature, controlled stance, modest attitude, and excellent listening skills, they tend to empathize with others’ perspectives. They value positive interactions and are always willing to help. They depend on more socially assertive people to take the lead. Their persistence and patience enable them to work steadily until the task is completed. They value trust strongly and enjoy being part of a smaller team where they are valued and appreciated. Typically, they resist change and need help in developing alternative solutions.",
    strengths:
      "Flexibility, dependability, harmony, warmth, listening, team-focused, loyal",
    uniqueness: "Listens effectively, supportive, works steadily",
    valtoorg:
      "Capable of dealing with laborious tasks; works on a task until it is achieved",
    challenges: "Sudden change; interruptions and distractions",
    motivations:
      "Helping others succeed; support of people; doing practical jobs",
  },
  {
    img_card: persuader,
    img_letter: persuaderletter,
    personality: "Persuader",
    text: "Persuaders are assertive, adventurous, and confident individuals with strong social skills. They can be charming or demanding, based on the circumstances. They tend to approach people and situations with energy. While communicating, they can be both assertive and persuasive. Their ability to think and react quickly lets them easily adapt to challenging situations. They have no fear of confrontation and address issues directly. They have clear goals in life and achieve them with sheer determination and commitment. Persuaders thrive in situations that others would find impossibly stressful and difficult. They live for and are happiest when on adventures.",
    strengths:
      "Charming, visionary, adventurous, bold, high energy, results-focused, exciting and fun",
    uniqueness:
      "Sound decision making, self-motivated, excels in emergencies",
    valtoorg:
      "Thrives under pressure; motivates people; commits and achieves results",
    challenges: "Stagnation; can get aggressive under pressure",
    motivations: "Success and recognition; new experiences and challenges",
  },
  {
    img_card: achiever,
    img_letter: achieverletter,
    personality: "Achiever",
    text: "This is an extremely rare profile with radically different sets of values and motivations. Achievers are reliable, persistent, tenacious, and industrious individuals with a strong sense of personal accountability. They like to get things done in a friendly but thorough manner. They are focused on results with a strong inclination towards fair play and respect. Their careful planning allows them to complete tasks within realistic timescales. They tend to be thoughtful in favorable conditions and demanding at times of pressure. Achievers are usually cautious and only open up to a small set of people they completely trust. They function at peak efficiency and expect recognition equal to their contribution.",
    strengths:
      "Patient, tenacious, dependable, consistent, protective, kind, watchful",
    uniqueness: "Methodical in approach; accountability of work",
    valtoorg: "Self-driven and completes tasks effectively",
    challenges: "Poor communication; inferior work",
    motivations: "Personal and professional accomplishments",
  },
  {
    img_card: perfectionist,
    img_letter: perfectionistletter,
    personality: "Perfectionist",
    text: "Perfectionists are tenacious, competitive, systematic, and creative individuals with opposing behavioral forces. They seek immediate results and have an equally strong desire for perfection. Their ability to plan and achieve quality allows them to make sound decisions. They think and act quickly but also evaluate all options before agreeing to a course of action. In their drive for results and perfection, they demand the freedom to explore and the authority to examine. They are straightforward and enjoy working by themselves. They tend to be careful with relationships and prefer a strategic approach when dealing with others. They are open to change but extremely cautious.",
    strengths:
      "Tenacity, quality control, handling large amounts of detail, analyzing data, building systems, competing to win, results-focused, striving to be the best",
    uniqueness:
      "Attention to detail; tries innovative approaches using existing systems",
    valtoorg:
      "Can bring positive change to the team by challenging them and raising the standards",
    challenges: "Bored with routine work; gets lost in detail",
    motivations: "Unique accomplishments and dominance",
  },
  {
    img_card: collaborator,
    img_letter: collaboratorletter,
    personality: "Collaborator ",
    text: "Collaborators are warm, empathetic, easygoing and relaxed individuals that socialize with ease. They tend to think of others first over themselves. They strive to maintain harmony and build long-term relationships. Being good listeners, they make others feel heard and offer suggestions gently. They are sympathetic in nature and fulfil supportive roles well. They often provide recognition to others and attribute less importance to task accomplishment. They love to work in team settings and appreciate environments that ensure stability with minimal change. While they generally avoid conflict and confrontation, they are willing to mediate with others to restore harmony.",
    strengths:
      "Versatile, warm, responsive, upbeat, respectful, loyal, enthusiastic",
    uniqueness: "Group acceptance and approval; friendliness",
    valtoorg:
      "Effective listening skills; bring stability and harmony to the team",
    challenges:
      "Conflicting situations; over-commitment; boredom; cannot confront or give direct orders.",
    motivations:
      "Recognition from people around; peaceful environment where they can collaborate with others",
  },
  {
    img_card: assessor,
    img_letter: assessorletter,
    personality: "Assessor",
    text: "Assessors are articulate, creative, organized, and well-researched individuals with a unique blend of contradicting traits. They seek the company of others but are also exhausted by them. On one hand, they are outgoing and impulsive in favorable conditions yet in formal situations, they are precise and rule-abiding. They are naturally skilled at influencing people with strong communication. They are imaginative, perceptive and strive for perfection. They elicit cooperation from others by being considerate. They have the desire to win and can overwork to the point of exhaustion. They are practical and ensure progressive results by developing a detailed plan of action.",
    strengths:
      "Articulate, well-researched, produce quality results, self-disciplined, careful, expressive, enthusiastic, fun",
    uniqueness:
      "Turning dreams into workable concepts; result-oriented and quality-driven",
    valtoorg:
      "Brings new ideas to the table; team players that instigate action and activities",
    challenges: "Not knowing when to stop; sensitive to criticism",
    motivations: "Winning attention and approval; succeeding at all costs",
  },
  {
    img_card: implementor,
    img_letter: implementorletter,
    personality: "Implementor ",
    text: "Implementors are stable, consistent, pragmatic, and accommodating individuals that are driven by patience, accuracy, and logic. They are precise thinkers and through precautions avoid the unexpected. They prefer traditional approaches. They question assumptions and require loads of information that they can analyze when exploring alternatives and before reaching conclusion. They enjoy overcoming challenges through persistence and intense focus. They are calm and rational folks, and they rarely provide input in a group. They hold themselves to high standards and desire to earn the respect of those around them.",
    strengths:
      "Dependable, stable, careful, accurate, hard working, patient, diplomatic",
    uniqueness: "Brings stability on board; sticks to “fail safe” options",
    valtoorg:
      "Works diligently to get the job done; maintains quality and standards",
    challenges: "Reluctant to change; takes time to adapt",
    motivations: "Predictable and stable outcomes; recognition for work",
  },
  {
    img_card: motivator,
    img_letter: motivatorletter,
    personality: "Motivator",
    text: "Motivators are dependable, social, assertive, and determined individuals that have a clear idea of their life goals and the will power to achieve them.They have a strong sense of independence.Their unique combination of patience and proactivity makes them effective facilitators and motivators.They thrive on working with people, challenging tasks, and spontaneity.They are warm, well- liked, competitive and result oriented.They get results and consider options before execution but do not get bogged down by too much detail or accuracy.They maintain good relations and motivate people around them.Their positive outlook might make them too optimistic, and they overestimate their ability to change the behaviour of others",
    strengths:
      "Dependable, socially skilled, patient, warm, interesting and fun, driven to achieve, self-reliant",
    uniqueness:
      "Clarity on goals and ways to accomplish; control over circumstances",
    valtoorg:
      "Confidently suggests innovative ideas; assigns tasks effectively",
    challenges:
      "Being asked to investigate too much detail; routine and regimen",
    motivations: "New opportunities; strong need to achieve",
  },
  {
    img_card: leader,
    img_letter: leaderletter,
    personality: "Leader",
    text: "Leaders are practical, innovative, self-reliant, and ambitious individuals that are always pushing to make things better. They are friendly, charming, and enthusiastic in casual circumstances but tend to be direct, forthright, and assertive in formal setups. They like taking responsibility and taking credit for both wins and losses, as long as they have control of the results. They do not shy away from taking command when needed and may be impatient with the inefficiencies of others. They are sensitive to the needs of the team. They find a balance between personal ambitions and group goals. They are very clear thinkers, make good decisions and promote harmony in the team.",
    strengths:
      "Driven, innovative, practical, self-reliant, leadership ability, confident, clear thinking",
    uniqueness: "Accommodating and inspiring; drive to make things better",
    valtoorg: "Persistently accomplishes goals with inclusivity of team",
    challenges:
      "Impatience when things don’t go a certain way; being managed",
    motivations:
      "Opportunity to get things done in their way; supporting the team",
  },
  {
    img_card: administrator,
    img_letter: administratorletter,
    personality: "Administrator ",
    text: "Administrators are steady, objective, clear-minded and analytical individuals that get results and keep the team happy at the same time. They have a clear view of their aims in life. Their patience and thoughtfulness help them avoid risks. They guard their thoughts and reveal them only after careful thought and consideration. They choose their words carefully, make practical decisions, and rely upon logic rather than emotion. They possess the drive to track detail and the desire to build the harmony needed to run the team. While being good executors, they rarely bring in the imagination and vision needed for innovative initiatives. They can be both dominant and supportive based on the situation.",
    strengths:
      "Productive, efficient, practical, pragmatic, thoughtful, detail-oriented, patient",
    uniqueness: "Uses logic effectively to get results",
    valtoorg:
      "Works with determination; can work individually or with others",
    challenges: "Tendency to get overworked; being blunt; not creative",
    motivations:
      "Achieving results by taking time to adapt to changing situations; attention to detail; avoiding risk",
  },
  {
    img_card: mediator,
    img_letter: mediatorLetter,
    personality: "Mediator ",
    text: "Mediators are creative, well-spoken, and understanding individuals that enjoy being a team member and helping others succeed. They love being in a supportive role and can bring valuable insights if given the time needed to think. They are rational in problem-solving and adept at presenting arguments in a credible manner. Their insistence on taking things at their own pace might not be agreeable to all. They prefer a cooperative environment where people are trustworthy and pleasant. They thrive on their contribution to projects that require attention to detail. They have high expectations of themselves and others around them and might voice disapproval when their expectations are not met.",
    strengths:
      "Productive, well-spoken, researching, harmonious, collaborative, co-operative, detail-oriented, patient",
    uniqueness: "Accommodating and inspiring",
    valtoorg: "Skilled and proficient in problem solving; highly skilled",
    challenges:
      "Aversion to risks and being too predictable; not recognized as experts.",
    motivations:
      "Supporting and interacting with others; learning from and teaching to others.",
  },
  {
    img_card: versatile,
    img_letter: achieverletter,
    personality: "All Rounder",
    text: "The All Rounders are individuals who exhibit a balanced mix of behaviours and traits which results in no specific aspect of their behaviour that stands out. This unique blend allows them to adapt to a wide range of situations and environments effectively. They may often encounter challenges with leadership roles that require consistency and direction. They might find it challenging to thrive in roles demanding strong personality traits or high performance and action, they excel in environments where a balanced approach is advantageous. Their flexibility enables alignment with diverse groups making them a valuable team player. Overall, they enrich any organization with their unique ability to perceive multiple perspectives.",
    strengths:
      "Fit into different contexts based on situational needs; Versatility in handling multiple tasks, Flexible",
    uniqueness:
      "Adaptability akin to a chameleon; Adept at multiple perspective-taking.",
    valtoorg:
      "Ideal for diverse departments; Bridge gaps between different personality types, Fosters collaboration.",
    challenges:
      "Overwhelmed in highly demanding or unfamiliar situations; Lack of specialization; Leadership roles; Lacks consistency.",
    motivations:
      "Stability in work environment; Easing into tasks; Opportunities to utilize adaptability and versatility.",
  },
]